if (window.appcuesConfig) {
    var accountId = impactX.isDefined(window, 'appcuesConfig.accountId');
    var scriptElement = document.createElement('script');
    var baseUrl = "//fast.appcues.com/";

    if (!accountId) {
        console.log("Appcues could not be initialized: missing AccountId in appcuesConfig");
    }
    else {
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.src = baseUrl + accountId + '.js';
        document.documentElement.insertBefore(scriptElement, document.body.nextSibling)
    }
}